import { render } from "./Portfolio.vue?vue&type=template&id=220cc484"
import script from "./Portfolio.vue?vue&type=script&setup=true&lang=js"
export * from "./Portfolio.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Portfolio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "220cc484"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('220cc484', __exports__)) {
    console.log('reload')
    api.reload('220cc484', __exports__)
  }
  
  module.hot.accept("./Portfolio.vue?vue&type=template&id=220cc484", () => {
    console.log('re-render')
    api.rerender('220cc484', render)
  })

}


export default __exports__